import { SingleTubeFormValues } from '../ProductsConfiguration'

export const getOligoListFromFileUpload = (value: any) => {
  const obj: any = JSON.parse(value)
  // Item have following data
  /*
            antisenceBaseCount,
            autoValidation,
            baseCount,
            comments,
            concentration,
            countryCode,
            decisionTableVer,
            epsilon,
            errorDecisionTableVer,
            fiveMod,
            flag,
            format,
            gcContent,
            id,
            isCSR,
            isCSRSupervisor,
            isLabelledAminoAcid,
            isLNABaseEnable,
            isOverridden,
            listConcentration,
            listError,
            listFiveMod ,
            listFormat,
            listInternalMod,
            listProductPackage,
            listPurification,
            listScale,
            listSequenceValidationError,
            listShippingOptions,
            listThreeMod ,
            listTubes,
            listWarning,
            mergedSession,
            minimumYield,
            molecularWeight,
            name,
            oligoCount,
            orderItemId,
            pageNo,
            primerDimer,
            probeType,
            productType,
            purification,
            scale,
            secondaryStructure,
            sequence,
            terms,
            threeMod,
            tubes,
        */
  const arr: SingleTubeFormValues[] = []
  obj.forEach((item: any) => {
    const {
      amount,
      antisenseBaseCount,
      antisenceBaseCount,
      antisenceFiveMod,
      antisenceName,
      antisenceSequence,
      antisenceThreeMod,
      autoGenerateOligo,
      baseCount,
      concentration,
      customerOverhang,
      customerAntisenseOverHang,
      fiveMod,
      format,
      name,
      purification,
      scale,
      senseNameCheck,
      sequence,
      threeMod,
      tubes,
      molecularWeight,
      secondaryStructure,
      primerDimer,
      meltingTemparature,
      gcContent,
      minimumYield,
      comments,
      additionalServices,
      otherValue,
      flag,
      internalMod,
      probeType,
    } = item
    arr.push({
      additionalServices,
      amount,
      antisenceBaseCount: antisenceBaseCount || Number(antisenseBaseCount),
      antisenceFiveMod: antisenceFiveMod || '',
      antisenceName,
      antisenceSequence,
      antisenceThreeMod: antisenceThreeMod || '',
      antisenseBaseCount: antisenceBaseCount || Number(antisenseBaseCount),
      autoGenerateOligo,

      baseCount,
      comments,
      concentration,
      customerAntisenseOverHang: customerAntisenseOverHang || '',
      customerOverhang: customerOverhang || '',
      displayPageError: item.listError && item.listError.length !== 0,
      enabledConcentrationData:
        item.listConcentration?.length === 1 &&
        item.listConcentration[0] === 'None'
          ? ['']
          : item.listConcentration,
      enabledFiveModifications: item.listFiveMod || [],
      enabledFormatData: item.listFormat || [],
      enabledInternalModifications: item.listInternalMod || [],
      enabledPurificationData: item.listPurification || [],
      enabledScaleData: item.listScale || [],
      enabledThreeModifications: item.listThreeMod || [],
      'five-reporter-three-quencher': internalMod
        ? `${fiveMod}/${internalMod}/${threeMod}`
        : `${fiveMod}/${threeMod}`,
      fiveMod,
      fiveModCategory: '',
      flag,
      format,
      gcContent,
      insertAsterisk: false,
      internalMod: internalMod,
      internalModCategory: '',
      listErrors: item.listError,
      listMinimumYield: minimumYield,
      listNumberOfTubes: item?.listTubes?.map((i) => Number(i)) || ['1'],
      listWarning: item.listWarning || [],
      meltingTemperature: meltingTemparature, //TODO: ASK BE team to correct the spelling
      molecularWeight,
      name,
      primerDimer,
      probeType,
      purification,
      scale,
      secondaryStructure,
      senseNameCheck,
      sequence,
      threeMod,
      threeModCategory: '',
      tubes: String(tubes),
      ...Object.assign({}, !otherValue ? null : { otherValue }),
    })
  })
  return arr
}
